import React, { FC, ReactNode } from 'react'

import { useNavigate } from 'react-router-dom'

import ErrorBoundary from './ErrorBoundary'

export const ErrorBoundaryContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate()
  return <ErrorBoundary navigate={navigate}>{children}</ErrorBoundary>
}
